import getConfig from 'next/config'
import { Theme } from '@afterpaytouch/core'

const { publicRuntimeConfig = {} } = getConfig()
const { config = {} } = publicRuntimeConfig

const parseConfig = (input, fallback) => {
  switch (typeof input) {
    case 'string':
      if (isNaN(Number(input)) || input.trim().length === 0) {
        return fallback
      }
      return Number(input)
    case 'number':
      return input
    default:
      return fallback
  }
}

export const api = {
  PORTAL_API_BASE_URL: config.PORTAL_API_BASE_URL ?? '',
  TOPAZ_BASE_URL: config.TOPAZ_BASE_URL ?? '',
  PAYMENT_SOURCE_BASE_URL: config.PAYMENT_SOURCE_BASE_URL ?? '',
  EVENT_ORDER_STATUS_BASE_URL: config.EVENT_ORDER_STATUS_BASE_URL ?? '',
  RULES_SERVICE_BASE_URL: config.RULES_SERVICE_BASE_URL ?? '',
  VERIFY_SERVICE_BASE_URL: config.VERIFY_SERVICE_BASE_URL ?? '',
  APPLE_GATEWAY_SERVICE_BASE_URL: config.APPLE_GATEWAY_SERVICE_BASE_URL ?? '',
  APPLE_GATEWAY_BASIC_AUTH_TOKEN: config.APPLE_GATEWAY_BASIC_AUTH_TOKEN ?? '',
  CASH_API_BASE_URL: config.CASH_API_BASE_URL ?? '',
  CASH_API_CLIENT_ID: config.CASH_API_CLIENT_ID ?? '',
}

export const app = {
  ADWORDS_ID: config.ADWORDS_ID ?? '',
  AMPLITUDE_CLIENT_SIDE_ID: config.AMPLITUDE_CLIENT_SIDE_ID ?? '',
  APP_ENVIRONMENT: config.APP_ENVIRONMENT ?? '',
  APP_VERSION: config.APP_VERSION ?? '',
  APPLE_PAY_MERCHANT_ID: config.APPLE_PAY_MERCHANT_ID ?? '',
  APPLE_PAY_ACQUIRING_MERCHANT_ID: config.APPLE_PAY_ACQUIRING_MERCHANT_ID ?? '',
  BRAND_NAME: config.BRAND_NAME ?? '',
  BROCHURE_BASE_URL: config.BROCHURE_BASE_URL ?? '',
  FRIENDBUY_MERCHANT_ID: config.FRIENDBUY_MERCHANT_ID ?? '',
  GOOGLEMAPS_API_KEY: config.GOOGLEMAPS_API_KEY ?? '',
  HELP_BASE_URL: config.HELP_BASE_URL ?? '',
  KASADA_SRC: config.KASADA_SRC ?? '',
  LAUNCH_DARKLY_CLIENT_SIDE_ID: config.LAUNCH_DARKLY_CLIENT_SIDE_ID ?? '5baa19e1a3050e21323b5e58',
  SNAP_CHAT_PIXEL_ID: config.SNAP_CHAT_PIXEL_ID ?? '',
  TM_ORGANISATION_ID: config.TM_ORGANISATION_ID ?? '',
  THREE_DS_REDIRECT_URL: config.THREE_DS_REDIRECT_URL ?? '',
  STRIPE_CARD_SCAN_PUBLISHABLE_KEY: config.STRIPE_CARD_SCAN_PUBLISHABLE_KEY ?? '',
  BOUNCER_SRC: config.BOUNCER_SRC ?? '',
  DYSCAN_API_KEY: config.DYSCAN_API_KEY ?? '',
  DYSCAN_SRC: config.DYSCAN_SRC ?? '',
  GOOGLE_TAG_MANAGER_ID: config.GOOGLE_TAG_MANAGER_ID ?? '',
  PORTAL_URL: config.PORTAL_URL ?? '',
  DATADOG_APP_ID: config.DATADOG_APP_ID ?? '',
  DATADOG_CLIENT_TOKEN: config.DATADOG_CLIENT_TOKEN ?? '',
  DATADOG_SERVICE: config.DATADOG_SERVICE ?? '',
  PERSONALIZATION_REDIRECTION_DELAY_MS: parseConfig(config.PERSONALIZATION_REDIRECTION_DELAY_MS, 10000),
  PERSONALIZATION_POSITIVE_ACTIONED_REDIRECTION_DELAY_MS: parseConfig(config.PERSONALIZATION_POSITIVE_ACTIONED_REDIRECTION_DELAY_MS, 2000),
  PERSONALIZATION_NEGATIVE_ACTIONED_REDIRECTION_DELAY_MS: parseConfig(config.PERSONALIZATION_NEGATIVE_ACTIONED_REDIRECTION_DELAY_MS, 0),
  PERSONALIZATION_POST_CAPTURE_TIMEOUT: parseConfig(config.PERSONALIZATION_POST_CAPTURE_TIMEOUT, 8000),
  BIOMETRIC_VERIFYING_ACCOUNT_IDENTITY_POLLING_INTERVAL: parseConfig(config.BIOMETRIC_VERIFYING_ACCOUNT_IDENTITY_POLLING_INTERVAL, 5000),
  BIOMETRIC_VERIFYING_DEFAULT_WAIT_TIME: parseConfig(config.BIOMETRIC_VERIFYING_DEFAULT_WAIT_TIME, 90000),
  BIOMETRIC_VERIFYING_TIME_OUT: parseConfig(config.BIOMETRIC_VERIFYING_TIME_OUT, 300000),
  ENABLE_VERBOSE_NON_PORTAL_API_ERRORS: config.ENABLE_VERBOSE_NON_PORTAL_API_ERRORS,
  TOKEN_NOTIFICATION_URL: config.TOKEN_NOTIFICATION_URL ?? '',
  COLD_START_THEME: config.COLD_START_THEME ?? Theme.AP,
  COLD_START_THEME_US: config.COLD_START_THEME_US ?? config.COLD_START_THEME,
  COLD_START_THEME_CA: config.COLD_START_THEME_CA ?? config.COLD_START_THEME,
  COLD_START_THEME_GB: config.COLD_START_THEME_GB ?? config.COLD_START_THEME,
  COLD_START_THEME_AU: config.COLD_START_THEME_AU ?? config.COLD_START_THEME,
  COLD_START_THEME_NZ: config.COLD_START_THEME_NZ ?? config.COLD_START_THEME,
  MERCHANT_ESTIMATE_PPA_IDS: config.MERCHANT_ESTIMATE_PPA_IDS ?? '',
  CONSUMER_BILLING_SHIPPING_COUNTRY_AS_INITIAL_LANGUAGE: config.CONSUMER_BILLING_SHIPPING_COUNTRY_AS_INITIAL_LANGUAGE ?? '',
  ENABLE_OTP_MERCHANT_ID: config.ENABLE_OTP_MERCHANT_ID ?? '',
  PERSONA_ENV_ID: config.PERSONA_ENV_ID ?? '',
  PERSONA_TEMPLATE_ID: config.PERSONA_TEMPLATE_ID ?? '',
  APPLE_RETAIL_MIDS: config.APPLE_RETAIL_MIDS ?? '',
  AP_COHORT_OFFER_LINK_URL: config.AP_COHORT_OFFER_LINK_URL ?? '',
  CASH_COHORT_OFFER_LINK_URL: config.CASH_COHORT_OFFER_LINK_URL ?? '',
}

export const DEBUG_MODE = publicRuntimeConfig.DEBUG_MODE

export const BASE_PATH = publicRuntimeConfig.BASE_PATH
